import {
  api,
  CreateExaminerTrainingRequest,
  ExaminerTraining,
  ExaminerTrainingHistoryResponse,
  ExaminerTrainingsResponse,
  Training,
  UpdateExaminerTrainingRequest,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const trainingStandardisationApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    trainingSessions: builder.query<Training[], void>({
      query: () => {
        return api.training.getAll();
      },
    }),

    trainingList: builder.query<ExaminerTrainingsResponse, { examinerId: number }>({
      query: ({ examinerId }) => {
        return api.examinerTraining.getExaminerTrainings({ examinerId });
      },
      providesTags: ['Training'],
    }),

    training: builder.query<ExaminerTraining, { examinerId: number; id: number }>({
      query: ({ examinerId }) => {
        return api.examinerTraining.getExaminerTrainings({ examinerId });
      },
      transformResponse: (response: ExaminerTrainingsResponse, _meta, arg) => {
        return response.examinerTrainings.find((t) => t.id === arg.id) as ExaminerTraining;
      },
      providesTags: ['Training'],
    }),

    createTraining: builder.mutation<
      void,
      { examinerId: number; training: CreateExaminerTrainingRequest }
    >({
      query: ({ training }) => {
        return api.examinerTraining.create(training);
      },
      invalidatesTags: ['Training', 'ExaminerStatus'],
    }),

    updateTraining: builder.mutation<
      void,
      { examinerId: number; id: number; training: UpdateExaminerTrainingRequest }
    >({
      query: ({ id, training }) => {
        return api.examinerTraining.update({ id }, training);
      },
      invalidatesTags: ['Training', 'ExaminerStatus'],
    }),

    trainingHistory: builder.query<ExaminerTrainingHistoryResponse, { id: number }>({
      query: ({ id }) => {
        return api.examinerTraining.getHistory({ id });
      },
      providesTags: ['Training'],
    }),
  }),
});

export const {
  useTrainingSessionsQuery,
  useTrainingListQuery,
  useTrainingQuery,
  useCreateTrainingMutation,
  useUpdateTrainingMutation,
  useTrainingHistoryQuery,
} = trainingStandardisationApi;
